import { render, staticRenderFns } from "./Question9.vue?vue&type=template&id=e5b79258&scoped=true&"
import script from "./Question9.vue?vue&type=script&lang=js&"
export * from "./Question9.vue?vue&type=script&lang=js&"
import style0 from "./Question9.vue?vue&type=style&index=0&id=e5b79258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b79258",
  null
  
)

export default component.exports